var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card-info" },
    [
      _c(
        "el-row",
        { staticClass: "tb d-flex", attrs: { align: "middle", gutter: "20" } },
        [
          _c(
            "el-col",
            {
              staticClass: "column",
              attrs: { span: _vm.prolongado ? 24 : 18 }
            },
            [
              _c("p", { staticClass: "verde-text text-aviso" }, [
                _vm._v(_vm._s(_vm.textAviso))
              ]),
              _c("p", { staticClass: "verde-text text-between" }, [
                _vm._v(_vm._s(_vm.textBetween))
              ])
            ]
          ),
          !_vm.prolongado
            ? _c(
                "el-col",
                { staticClass: "botao", attrs: { span: 4 } },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "green textButtonBreak",
                      attrs: { tipo: "success" },
                      on: { click: _vm.prolongar }
                    },
                    [
                      _c("span", { staticClass: "center" }, [
                        _c("i", { staticClass: "fal fa-credit-card" }),
                        _vm._v("  Prolongar prazo")
                      ])
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b8b5fc8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b8b5fc8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/components/centralMensagens/AppAvisoNotificacao.vue
// module id = null
// module chunks = 